'use strict';

import controller from './formularioProducto.controller';
import template from './formularioProducto.html';
// import './inputChips.scss';

const formularioProductoComponent = {
    bindings: {
        ngModel: '=',
        ngRequired: '<',
        beforeAdd: '&',
        onRemove: '&',
        label: '@',
        ngDisabled: '<',
        ngUppercase: '<',
        ngPlaceholder: '@',
        idCertificacion:'<',
        data:'<'
    },
    controller,
    template
};

export default formularioProductoComponent;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/formularioProducto/formularioProducto.component.js